import { ACCESS_TOKEN_KEY } from '@/constants/common'

import { getCookieValue } from '../helper'

const deleteCart = async (cardId: string) => {
  try {
    const token = getCookieValue(ACCESS_TOKEN_KEY)
    fetch(
      `${process.env.NEXT_PUBLIC_API_BASE_URL}/hyperlocal/v1/delete/cart/${cardId}`,
      {
        method: 'DELETE',
        headers: {
          Authorization: `Bearer ${token}`,
          'Content-Type': 'application/json',
        },
        keepalive: true, // ensures request is sent even if page unloads
      },
    )
  } catch {
    return false
  }
}

export default deleteCart
